<template>
	<div>
		<SoftSwitch v-model="oplVisible" class="m-2" :label="$t('dataType.overpressure')" />
	</div>
</template>

<script lang="ts">
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { defineComponent } from "vue";
import { defaultVibEventOptions, VibEventOptions } from "./vib-event-options";

export default defineComponent({
	name: "VibEventPluginConfig",
	props: {
		modelValue: {
			type: Object as PropType<VibEventOptions>,
			default: () => defaultVibEventOptions,
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);
		const oplVisible = useRefObjectSync(valueModel, "oplVisible");

		return { oplVisible };
	},
});
</script>
